import { NOT_SPECIFIED } from 'customer-data-objects/property/AccessLevel';
import { REFERENCE_RECORD } from 'customer-data-filters-ui/filterQueryFormat/DSFieldRecord/formatter/FormatTypes';
import { AppObjectTypeIdRegex } from '../../../filterQueryFormat/ObjectTypeId';
import { Map as ImmutableMap, fromJS } from 'immutable';
import { getFrameworkDataSchemasClient } from 'framework-data-schema-resolvers';
import { toDSFieldRecord } from 'customer-data-filters-ui/filterQueryFormat/DSFieldRecord/toDSFieldRecord';
import Adapter from './Adapter';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ReferenceRecord from 'reference-resolvers/schema/ReferenceRecord';
import http from 'hub-http/clients/apiClient';
const mapPropertyToReferenceRecord = propertyDefinition => {
  const {
    property,
    permission
  } = propertyDefinition;
  return new ReferenceRecord({
    id: property.name,
    label: property.label,
    description: property.type,
    referencedObject: fromJS(
    // Add accessLevel field if present, only if HIDDEN or READ_ONLY
    permission !== null && permission !== void 0 && permission.accessLevel && permission.accessLevel !== NOT_SPECIFIED ? Object.assign({}, property, {
      accessLevel: permission.accessLevel
    }) : property)
  });
};
export const mapGroupsToPropertyDSFieldRecords = (groupsWithPropertyDefinitions, assetFamily) => {
  const referenceRecords = groupsWithPropertyDefinitions
  // Extract property defs
  .flatMap(({
    propertyDefinitions
  }) => propertyDefinitions || [])
  // Map into immutable format
  .reduce((propertyMap, propertyDefinition) => propertyMap.set(propertyDefinition.property.name, mapPropertyToReferenceRecord(propertyDefinition)), ImmutableMap());
  return toDSFieldRecord(referenceRecords, assetFamily, REFERENCE_RECORD);
};
export class AppObjectPropertiesAdapterConfig {
  constructor() {
    this.performanceTrackingKey = 'AppObjectPropertiesAdapter';
  }
  getCacheKey() {
    return 'APP_OBJECT_PROPERTIES';
  }
  isAssetFamilySupported(assetFamily) {
    return AppObjectTypeIdRegex.test(assetFamily);
  }
  getFetcher() {
    return getFrameworkDataSchemasClient.bind({
      httpClient: http
    });
  }
  fetchData(frameworkDataSchemasClient, assetFamily) {
    return frameworkDataSchemasClient().then(client => client.properties.getGroups({
      frameworkTypeIdentifier: assetFamily
    }));
  }
  formatData(groupsWithPropertyDefinitions, assetFamily) {
    return mapGroupsToPropertyDSFieldRecords(groupsWithPropertyDefinitions, assetFamily);
  }
}
export default Adapter.makeFromConfig(AppObjectPropertiesAdapterConfig);